import {
  VERTICAL_NAMES,
  BUSINESS_VERTICAL_IDS,
} from "../../../constants/constants";
import filterProfilesByVertical from "../../../utils/filterProfilesByVertical";

export const filterMatchedProfiles = (
  response,
  values,
  verticalObj,
  selectedBranch,
) => {
  const matchedProfiles = filterProfilesByVertical(
    response?.data?.accounts,
    verticalObj?.id,
    { uam_id: values.uam_id, admission_number: values.admission_number },
  );

  if (values.vertical === VERTICAL_NAMES.IL_SCHOOLS && selectedBranch?.id) {
    return matchedProfiles.filter(
      ({ profile }) =>
        profile.verticalId === BUSINESS_VERTICAL_IDS.IL_SCHOOLS &&
        profile.branchId === selectedBranch.id,
    );
  }

  return matchedProfiles;
};
